module.exports = __webpack_public_path__ + "images/add_lead_btn.gif";